module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "icon-pdf-style",
    attrs: {
      "src": require('@/assets/icon/icon_pdf.png')
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(this.fileName))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(Math.round(this.fileSize / 1024)) + "KB")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "35px"
    }
  }, [_vm._v("\n    点击下载后，可点击右上角【•••】将文件保存到手机\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "down",
    on: {
      "click": function($event) {
        return _vm.download()
      }
    }
  }, [_vm._v("下载")]), _vm._v(" "), _c('div', {
    staticClass: "send",
    on: {
      "click": function($event) {
        return _vm.send()
      }
    }
  }, [_vm._v("发送至邮箱")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8ba4c01a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views_fc/BoSolution/PdfPage.vue
// module id = 1690
// module chunks = 8